// shared.module.ts
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TimeFormatPipe } from './time-format.pipe';

@NgModule({
  imports: [IonicModule],
  declarations: [TimeFormatPipe],
  exports: [TimeFormatPipe],
})
export class PipeModule {}
